<h1 mat-dialog-title>Információ</h1>
<div mat-dialog-content>
  <div>
    Bármi kérdésed van, információt szeretnél, kérlek, küldd el a
    <a href="mailto:licencemanager@ecsi.io?subject=Információ"
      >licencemanager@ecsi.io</a
    >
    címre.
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onOkClick()">Bezár</button>
</div>
